import ts from 'typescript';
import type { Evaluator } from '../types';

const evaluateElementAccessExpression: Evaluator<ts.ElementAccessExpression> = ({
  node,
  variables,
  log,
  evaluators,
}) => {
  // idx might actually be a number with the thing being an array.
  // to simplify just assume it's a string looking up in an object, not checking the tsc anyway...
  const objectOrArray = evaluators.expression({
    evaluators,
    log,
    node: node.expression,
    variables,
  });

  const key = evaluators.expression({
    evaluators,
    log,
    node: node.argumentExpression,
    variables,
  });

  if (
    key === null
    || key === undefined
    || key instanceof Error
    || objectOrArray === null
    || objectOrArray === undefined
    || objectOrArray instanceof Error
  ) {
    return undefined;
  }

  // don't strictly check the type, just let javascript try.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return (objectOrArray as any)[key as any];
};

export default evaluateElementAccessExpression;
